const formatTelefone = (telefone: string) => {
  if (!telefone) return "";

  const numeros = telefone.replace(/\D/g, "");

  // Brasil com DDI +55
  if (numeros.startsWith("55")) {
    const numero = numeros.substring(2);

    // Celular: +55 (71) 99999-9999
    if (numero.length === 11) {
      return `+55 (${numero.substring(0, 2)}) ${numero.substring(
        2,
        7,
      )}-${numero.substring(7)}`;
    }

    // Fixo: +55 (71) 9999-9999
    if (numero.length === 10) {
      return `+55 (${numero.substring(0, 2)}) ${numero.substring(
        2,
        6,
      )}-${numero.substring(6)}`;
    }
  }

  // Outros países: mantém com +
  return `+${numeros}`;
};

export default formatTelefone;
